import { ContainerModule } from 'inversify';
import { BreadcrumbService, BreadcrumbServiceSymbol } from '@/app/breadcrumb/breadcrumb-service';

export const breadcrumbModule = new ContainerModule((bind) => {
  bind<BreadcrumbService>(BreadcrumbServiceSymbol).to(BreadcrumbService).inSingletonScope();
});
